import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../api/api';

const ActivateAccount = () => {
    const { token } = useParams(); // Lấy token từ URL
    const [status, setStatus] = useState('loading'); // Trạng thái kích hoạt: loading, success, error
    const [isActivated, setIsActivated] = useState(false);

    useEffect(() => {
        if (isActivated) return; // Ngăn gọi lại nếu đã thực hiện
        setIsActivated(true);
        console.log("useEffect triggered");


        const activateAccount = async () => {
            try {
                const response = await axios.get(`/auth/activate/${token}`);
                console.log("API Response: ", response);
                if (response.status === 200) {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch (error) {
                console.error('Error activating account:', error);
                setStatus('error');
            }
        };

        activateAccount();
        console.log("Component render");

    }, [token, isActivated]);

    return (
        <div className="container mt-5">
            {status === 'loading' && (
                <p>Đang xử lý yêu cầu kích hoạt tài khoản của bạn. Vui lòng đợi...</p>
            )}
            {status === 'success' && (
                <div>
                    <h1>Kích hoạt tài khoản thành công!</h1>
                    <p>Bạn có thể đăng nhập ngay bây giờ.</p>
                    <a href="/login" className="btn btn-primary">Đăng nhập</a>
                </div>
            )}
            {status === 'error' && (
                <div>
                    <h1>Không thể kích hoạt tài khoản</h1>
                    <p>Liên kết kích hoạt không hợp lệ hoặc đã hết hạn.</p>
                    <a href="/register" className="btn btn-secondary">Đăng ký lại</a>
                </div>
            )}
        </div>
    );
};

export default ActivateAccount;
